module.exports = __webpack_public_path__ + "media/images/icons/arrow-down-7bff1aae76a1215b02b8da9285d02615.svg";